//#region Styles
import { Container } from "./styles";
//#endregion
//#region Images
import BellIcon from "icons/BellIcon";
//#endregion

const NotificationVirtualEvent = () => {
    return (
        <Container>
            <BellIcon/>
            <span>
                Recuerda: La asistencia se tomará automaticamente al final del día
            </span>
        </Container>
    );
}

export default NotificationVirtualEvent;